<div class="backBackground">
    <div class="transitionEffectAll600 roundedCorner"
        [ngClass]="{'mainZero' : auth.currentUserIDSig()?.uid == null, 'mainMax' : sb.currentSidebarSize() === 'max' && auth.currentUserIDSig()?.uid != null,'mainMin' : sb.currentSidebarSize() === 'min' && auth.currentUserIDSig()?.uid != null}"
        *transloco="let t">
        <div class="page-content container-fluid base-font-color">
            <div class="row">
                <div class="col p-0 p-md-1">
                    @if (auth.currentUserIDSig()?.uid != null) {
                    @if(showSpinner || !this.auth.currentLangSig()?.lang) {
                    <div class="row">
                        <div class="col">
                            <span class="placeholder-glow">
                                <span class="placeholder placeholder-lg col-4"></span>
                            </span>
                        </div>
                    </div>
                    <div class="row mt-5">
                        <div class="col text-center">
                            <div class="svl-ripple">
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                    </div>
                    }
                    @if(!showSpinner && this.auth.currentLangSig()?.lang) {
                    <div class="page-header base-font-color">
                        <h2 title="{{t('categories.header-title')}}">{{t('categories.header-title')}}</h2>
                    </div>
                    <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-gap-2 row-gap-2 my-3">
                        <div class="col" *ngFor="let category of catsArray; index as i;">
                            <div class="card"
                                title="{{t('categories.card-title-category', { cat: category.content['name'] })}}">
                                <div class="card-body">
                                    <div class="d-flex justify-content-between align-items-center"
                                        style="height: 61px;">
                                        <span class="align-middle">{{category.content['name']}}</span>
                                        <span class="material-symbols-outlined method-button method-blue"
                                            (click)="this.listOfSubCats(category.id, this.auth.currentUserIDSig()?.uid); this.selectedCategory = i;"
                                            data-bs-toggle="modal" data-bs-target="#categoriesModal"
                                            title="{{t('categories.card-title-edit-category', { cat: category.content['name'] })}}">
                                            tune
                                        </span>
                                    </div>
                                </div>
                            </div>

                        </div>

                        @if(catsArray.length < maxNumberOfCategories) { <div class="col">
                            <div class="alert alert-white border-dashed d-flex">
                                <div class="col text-center" style="height: 61px;">
                                    <div class="d-flex justify-content-center align-items-center" style="height: 61px;">
                                        <span class="material-symbols-outlined method-button method-blue"
                                            data-bs-toggle="modal" data-bs-target="#newCategoryModal"
                                            title="{{t('categories.add-category')}}">
                                            add_circle
                                        </span>
                                    </div>

                                </div>
                            </div>
                    </div>
                    }
                </div>
                }




                }
                @if (auth.currentUserIDSig()?.uid == null) {
                <div class="row">
                    <div class="col">
                        <span class="placeholder-glow">
                            <span class="placeholder placeholder-lg col-4"></span>
                        </span>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col text-center">
                        <div class="svl-ripple">
                            <div></div>
                            <div></div>
                        </div>
                    </div>
                </div>
                }
            </div>
        </div>
    </div>
</div>
</div>
<!-- MODALS -->

<div class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" id="newCategoryModal" tabindex="-1"
    aria-labelledby="newCategoryModalLabel" aria-hidden="true" *transloco="let t">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body">
                <div class="row">
                    <div class="col text-end">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                            title="{{t('general.button-close')}}" (click)="newCategoryForm.resetForm()"></button>
                    </div>
                </div>
                <div class="row">
                    <div class="col text-center">
                        <span class="material-symbols-outlined modal-icon-green align-content-center">
                            add_notes
                        </span>
                    </div>
                </div>
                <form #newCategoryForm="ngForm">
                    @if (!this.auth.currentLangSig()?.lang) {
                    <p class="placeholder-glow mt-3">
                        <span class="placeholder placeholder-lg col-12"></span>
                    </p>
                    <p class="placeholder-glow mt-3">
                        <span class="placeholder placeholder-lg col-12"></span>
                    </p>
                    <p class="placeholder-glow mt-3">
                        <span class="placeholder placeholder-lg col-12"></span>
                    </p>
                    <p class="placeholder-glow mt-3">
                        <span class="placeholder placeholder-lg col-12"></span>
                    </p>
                    }
                    @if (this.auth.currentLangSig()?.lang) {
                    <div class="row mt-3">
                        <div class="col text-center">
                            <div class="my-4 text-center">
                                <h5>{{t('categories.category-name')}}</h5>
                            </div>
                            <input type="text" class="form-control" required
                                [class.is-invalid]="name.invalid && name.touched" [(ngModel)]="categoryModel.name"
                                #name="ngModel" name="name" placeholder="{{categoryModel.name}}">
                            <div class="invalid-feedback">{{t('general.form-feedback')}}</div>
                            <br>
                            <i>{{t('categories.category-label')}}</i>
                            <br>
                            <input type="text" class="form-control" required
                                [class.is-invalid]="label.invalid && label.touched" [(ngModel)]="categoryModel.label"
                                #label="ngModel" name="label" placeholder="{{categoryModel.label}}">
                            <div class="invalid-feedback">{{t('general.form-feedback')}}</div>
                        </div>
                    </div>
                    }
                </form>

                <hr>
                <div class="row  mb-2">
                    <div class="col">
                        @if (!this.auth.currentLangSig()?.lang) {
                        <p class="placeholder-glow">
                            <span class="placeholder placeholder-lg col-12"></span>
                        </p>
                        <p class="placeholder-glow mt-3">
                            <span class="placeholder placeholder-lg col-12"></span>
                        </p>
                        }
                        @if (this.auth.currentLangSig()?.lang) {
                        <h5>Info</h5>
                        <span class="fst-italic"><small>{{t('categories.general-info-header')}}</small></span>
                        }
                    </div>
                </div>

                <div class="modal-footer px-0">
                    <div class="container-fluid">

                        @if (!this.auth.currentLangSig()?.lang) {
                        <p class="card-text placeholder-glow">
                            <span class="placeholder col-3"></span>
                            <span class="placeholder bg-white col-1"></span>
                            <span class="placeholder bg-primary col-8"></span>
                        </p>
                        }
                        @if (this.auth.currentLangSig()?.lang) {
                        <div class="row">
                            <div class="col-4 d-grid">
                                <button class="btn btn-sm btn-link btn-link-secondary" type="button"
                                    data-bs-dismiss="modal" (click)="newCategoryForm.resetForm()"
                                    title="{{t('general.button-cancel')}}">
                                    {{t('general.button-cancel')}}</button>
                            </div>
                            <div class="col-8 d-grid">
                                <button class="btn btn-sm btn-secondary rounded-pill" data-bs-dismiss="modal"
                                    [class.disabled]="newCategoryForm.invalid" type="button"
                                    (click)="this.addCategory(this.auth.currentUserIDSig()?.uid); newCategoryForm.resetForm()">{{t('categories.button-add')}}</button>
                            </div>
                        </div>
                        }

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" id="renameCategoryModal" tabindex="-1"
    aria-labelledby="renameCategoryModalLabel" aria-hidden="true" *transloco="let t">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body">
                <div class="row">
                    <div class="col text-end">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                            title="{{t('general.button-close')}}" (click)="renameCategoryForm.resetForm()"></button>
                    </div>
                </div>
                <div class="row">
                    <div class="col text-center">
                        <span class="material-symbols-outlined modal-icon-grey align-content-center">
                            draw
                        </span>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col text-center">
                        <div class="my-4 text-center">
                            @if (!this.auth.currentLangSig()?.lang) {
                            <p class="placeholder-glow">
                                <span class="placeholder placeholder-lg col-12"></span>
                            </p>
                            }
                            @if (this.auth.currentLangSig()?.lang) {
                            <h5>{{t('categories.category-rename')}}</h5>
                            }
                        </div>
                        <form #renameCategoryForm="ngForm">
                            @if(selectedCategory > -1) {
                            <input type="text" class="form-control" required
                                [class.is-invalid]="name.invalid && name.touched" [(ngModel)]="categoryModel.name"
                                #name="ngModel" name="name"
                                placeholder="{{catsArray[this.selectedCategory].content['name']}}">
                            }

                            <div class="invalid-feedback">{{t('general.form-feedback')}}</div>

                            <br>
                            <i>{{t('categories.category-label')}}</i>
                            <br>
                            @if(selectedCategory > -1) {
                            <input type="text" class="form-control" required [(ngModel)]="categoryModel.label"
                                [class.is-invalid]="label.invalid && label.touched" #label="ngModel" name="label"
                                placeholder="{{catsArray[this.selectedCategory].content['label']}}">
                            }
                            <div class="invalid-feedback">{{t('general.form-feedback')}}</div>
                        </form>
                    </div>
                </div>



                <hr>
                @if (!this.auth.currentLangSig()?.lang) {
                <p class="placeholder-glow">
                    <span class="placeholder placeholder-lg col-12"></span>
                </p>
                <p class="placeholder-glow">
                    <span class="placeholder placeholder-lg col-12"></span>
                    <span class="placeholder placeholder-lg col-12"></span>
                    <span class="placeholder placeholder-lg col-12"></span>
                </p>
                }
                @if (this.auth.currentLangSig()?.lang) {
                <h5>Info</h5>
                <ol class="fst-italic">
                    <small>
                        <li>{{t('categories.cat-rename-warning-one')}}</li>
                        <li>{{t('categories.cat-rename-warning-two')}}</li>
                        <li>{{t('categories.cat-rename-warning-three')}}</li>
                    </small>
                </ol>
                }

                <div class="modal-footer px-0">
                    <div class="container-fluid">
                        @if (!this.auth.currentLangSig()?.lang) {
                        <p class="card-text placeholder-glow">
                            <span class="placeholder col-3"></span>
                            <span class="placeholder bg-white col-1"></span>
                            <span class="placeholder bg-primary col-8"></span>
                        </p>
                        }
                        @if (this.auth.currentLangSig()?.lang) {
                        <div class="row">
                            <div class="col-4 d-grid">
                                <button class="btn btn-sm btn-link btn-link-secondary" type="button"
                                    data-bs-toggle="modal" data-bs-target="#categoriesModal"
                                    (click)="renameCategoryForm.resetForm()" title="{{t('general.button-cancel')}}">
                                    {{t('general.button-cancel')}}</button>
                            </div>
                            <div class="col-8 d-grid">
                                <button class="btn btn-sm btn-secondary rounded-pill" data-bs-dismiss="modal"
                                    type="button" [class.disabled]="renameCategoryForm.invalid"
                                    (click)="this.renameCategory(this.categoryModel, this.catsArray[this.selectedCategory].id,this.auth.currentUserIDSig()?.uid); renameCategoryForm.resetForm()">{{t('general.button-update')}}</button>
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" id="deleteCategoryModal" tabindex="-1"
    aria-labelledby="deleteCategoryModalLabel" aria-hidden="true" *transloco="let t">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body">
                <div class="row">
                    <div class="col text-end">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                            title="{{t('general.button-close')}}"></button>
                    </div>
                </div>
                <div class="row">
                    <div class="col text-center">
                        <span class="material-symbols-outlined modal-icon-red align-content-center">
                            delete
                        </span>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col text-center">
                        @if(this.catsArray) {
                        <strong>{{t('categories.xxx-remove-category')}}:
                            {{catsArray[this?.selectedCategory ?? 0]?.content['name']}}</strong>
                        <br>
                        <i>{{t('categories.irreversible')}}</i>
                        }
                    </div>
                </div>
            </div>
            <div class="modal-footer px-0">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-4 d-grid">
                            <button class="btn btn-sm btn-link btn-link-secondary" type="button" data-bs-toggle="modal"
                                data-bs-target="#categoriesModal" title="{{t('general.button-cancel')}}">
                                {{t('general.button-cancel')}}</button>
                        </div>
                        <div class="col-8 d-grid">
                            <button class="btn btn-sm btn-secondary rounded-pill" data-bs-dismiss="modal" type="button"
                                (click)="this.deleteCategory(this.catsArray[this.selectedCategory].id,this.auth.currentUserIDSig()?.uid)">{{t('general.button-delete')}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" id="newSubCategoryModal" tabindex="-1"
    aria-labelledby="newSubCategoryModalLabel" aria-hidden="true" *transloco="let t">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body">
                <div class="row">
                    <div class="col text-end">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                            title="{{t('general.button-close')}}" (click)="newSubCategoryForm.resetForm()"></button>
                    </div>
                </div>
                <div class="row">
                    <div class="col text-center">
                        <span class="material-symbols-outlined modal-icon-green align-content-center">
                            add_notes
                        </span>
                    </div>
                </div>

                <form #newSubCategoryForm="ngForm">
                    @if (!this.auth.currentLangSig()?.lang) {
                    <p class="placeholder-glow mt-3">
                        <span class="placeholder placeholder-lg col-12"></span>
                        <span class="placeholder placeholder-lg col-12"></span>
                    </p>
                    }
                    @if (this.auth.currentLangSig()?.lang) {
                    <div class="row mt-3">
                        <div class="col text-center">
                            <div class="my-4 text-center">
                                <h5>{{t('categories.subcategory-name')}}</h5>
                            </div>
                            <input type="text" class="form-control" required
                                [class.is-invalid]="name.invalid && name.touched" [(ngModel)]="subCategoryModel.name"
                                #name="ngModel" name="name">
                            <div class="invalid-feedback">{{t('general.form-feedback')}}</div>
                        </div>
                    </div>
                    }
                </form>
                <hr>
                <div class="row  mb-2">
                    <div class="col">
                        @if (!this.auth.currentLangSig()?.lang) {
                        <p class="placeholder-glow mt-1">
                            <span class="placeholder placeholder-lg col-12"></span>
                            <span class="placeholder placeholder-lg col-12"></span>
                        </p>
                        }
                        @if (this.auth.currentLangSig()?.lang) {
                        <h5>Info</h5>
                        <span class="fst-italic"><small>{{t('categories.general-info-header')}}</small></span>
                        }
                    </div>
                </div>
                <div class="modal-footer px-0">
                    <div class="container-fluid">
                        @if (!this.auth.currentLangSig()?.lang) {
                        <p class="card-text placeholder-glow">
                            <span class="placeholder col-3"></span>
                            <span class="placeholder bg-white col-1"></span>
                            <span class="placeholder bg-primary col-8"></span>
                        </p>
                        }
                        @if (this.auth.currentLangSig()?.lang) {
                        <div class="row">
                            <div class="col-4 d-grid">
                                <button class="btn btn-sm btn-link btn-link-secondary" type="button"
                                    data-bs-toggle="modal" data-bs-target="#categoriesModal"
                                    (click)="newSubCategoryForm.resetForm()" title="{{t('general.button-cancel')}}">
                                    {{t('general.button-cancel')}}</button>
                            </div>
                            <div class="col-8 d-grid">
                                <button class="btn btn-sm btn-secondary rounded-pill" data-bs-dismiss="modal"
                                    type="button" [class.disabled]="newSubCategoryForm.invalid"
                                    (click)="this.addSubCategory(this.subCategoryModel, this.catsArray[this.selectedCategory].id,this.auth.currentUserIDSig()?.uid); newSubCategoryForm.resetForm()">{{t('general.button-update')}}</button>
                            </div>
                        </div>
                        }

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" id="renameSubCategoryModal" tabindex="-1"
    aria-labelledby="renameSubCategoryModalLabel" aria-hidden="true" *transloco="let t">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body">
                <div class="row">
                    <div class="col text-end">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                            title="{{t('general.button-close')}}" (click)="renameSubCategoryForm.resetForm()"></button>
                    </div>
                </div>
                <div class="row">
                    <div class="col text-center">
                        <span class="material-symbols-outlined modal-icon-grey align-content-center">
                            draw
                        </span>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col text-center">
                        @if(this.subCatsArray) {
                        <i>{{this.subCatsArray[this?.selectedSubCategory ?? 0]?.content['name']}}</i>
                        }
                        <div class="my-3 text-center">
                            @if (!this.auth.currentLangSig()?.lang) {
                            <p class="placeholder-glow">
                                <span class="placeholder placeholder-lg col-12"></span>
                            </p>
                            }
                            @if (this.auth.currentLangSig()?.lang) {
                            <h5>{{t('categories.subcategory-rename')}}</h5>
                            }


                            <form #renameSubCategoryForm="ngForm">
                                @if(this.subCatsArray) {
                                <input type="text" class="form-control" required
                                    [class.is-invalid]="name.invalid && name.touched"
                                    [(ngModel)]="subCategoryModel.name" #name="ngModel" name="name"
                                    placeholder="{{this.subCatsArray[this?.selectedSubCategory]?.content['name']}}">
                                <div class="invalid-feedback">{{t('general.form-feedback')}}</div>
                                }
                            </form>
                        </div>

                    </div>
                </div>
                <div class="modal-footer px-0">
                    <div class="container-fluid">
                        @if (!this.auth.currentLangSig()?.lang) {
                        <p class="card-text placeholder-glow">
                            <span class="placeholder col-3"></span>
                            <span class="placeholder bg-white col-1"></span>
                            <span class="placeholder bg-primary col-8"></span>
                        </p>
                        }
                        @if (this.auth.currentLangSig()?.lang) {
                        <div class="row">
                            <div class="col-4 d-grid">
                                <button class="btn btn-sm btn-link btn-link-secondary" type="button"
                                    data-bs-toggle="modal" data-bs-target="#categoriesModal"
                                    (click)="renameSubCategoryForm.resetForm()" title="{{t('general.button-cancel')}}">
                                    {{t('general.button-cancel')}}</button>
                            </div>
                            <div class="col-8 d-grid">
                                <button class="btn btn-sm btn-secondary rounded-pill" data-bs-dismiss="modal"
                                    type="button" [class.disabled]="renameSubCategoryForm.invalid"
                                    (click)="this.renameSubCategory(this.subCategoryModel, this.catsArray[this.selectedCategory].id, this.subCatsArray[this.selectedSubCategory].id,this.auth.currentUserIDSig()?.uid); renameSubCategoryForm.resetForm()">{{t('general.button-update')}}</button>
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" id="deleteSubCategoryModal" tabindex="-1"
    aria-labelledby="deleteSubCategoryModalLabel" aria-hidden="true" *transloco="let t">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body">
                <div class="row">
                    <div class="col text-end">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                            title="{{t('general.button-close')}}"></button>
                    </div>
                </div>
                <div class="row">
                    <div class="col text-center">
                        <span class="material-symbols-outlined modal-icon-red align-content-center">
                            delete
                        </span>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col text-center">
                        @if(this.subCatsArray) {
                        <strong>{{t('categories.remove-subcategory')}}:
                            {{this.subCatsArray[this.selectedSubCategory]?.content['name']}}</strong>
                        <br>
                        <i>{{t('categories.irreversible')}}</i>
                        }
                    </div>
                </div>
            </div>
            <div class="modal-footer px-0">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-4 d-grid">
                            <button class="btn btn-sm btn-link btn-link-secondary" type="button" data-bs-toggle="modal"
                                data-bs-target="#categoriesModal" title="{{t('general.button-cancel')}}">
                                {{t('general.button-cancel')}}</button>
                        </div>
                        <div class="col-8 d-grid">
                            <button class="btn btn-sm btn-secondary rounded-pill" data-bs-dismiss="modal" type="button"
                                (click)="this.deleteSubCategory(this.catsArray[this.selectedCategory].id, this.subCatsArray[this.selectedSubCategory].id,this.auth.currentUserIDSig()?.uid)">{{t('general.button-delete')}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="categoriesModal" tabindex="-1" aria-labelledby="categoriesModalLabel" aria-hidden="true"
    *transloco="let t">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body">
                <div class="row">
                    <div class="col text-end">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                            title="{{t('general.button-close')}}"></button>
                    </div>
                </div>
                <hr>
                <div class="row my-2">
                    <div class="col text-start">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                @if(!catsArray || !this.auth.currentLangSig()?.lang) {
                                <div class="placeholder-glow">
                                    <span class="placeholder col-8 bg-dark">placeholderText</span>
                                </div>
                                }
                                @if(catsArray && this.auth.currentLangSig()?.lang) {
                                <strong>{{catsArray[this.selectedCategory]?.content['name']}}</strong>
                                <br>
                                <i>{{catsArray[this.selectedCategory]?.content['label']}}</i>
                                }
                            </div>
                            <div>
                                <span class="material-symbols-outlined method-button method-blue"
                                    data-bs-target="#renameCategoryModal" data-bs-toggle="modal"
                                    title="{{t('categories.title-rename-category')}}">
                                    edit
                                </span>
                                <span class="material-symbols-outlined method-button method-red"
                                    data-bs-target="#deleteCategoryModal" data-bs-toggle="modal"
                                    title="{{t('categories.title-delete-category')}}">
                                    delete
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="row">
                    <div class="col">
                        @if(!catsArray || !this.auth.currentLangSig()?.lang) {
                        <div class="placeholder-glow text-center">
                            <span class="placeholder col-8 bg-dark">placeholderText</span>
                        </div>
                        }
                        @if(catsArray && this.auth.currentLangSig()?.lang) {
                        @if(subCatsArray.length > 0 && subCatsArray.length <= maxNumberOfSubcategories) { <div
                            class="col text-center">
                            <p><em>{{t('categories.subcategories')}}:
                                    ({{subCatsArray.length}}/{{maxNumberOfSubcategories}})</em></p>
                    </div>
                    }
                    @if(subCatsArray.length == 0) {
                    <div class="col text-center">
                        <p><em>{{t('categories.no-subcategory')}}</em></p>
                    </div>
                    }
                    }
                </div>
            </div>
            <div class="row">
                <div class="col-xl-6 col-lg-12 col-md-6 col-sm-6 col-xs-1"
                    *ngFor="let subCategory of subCatsArray; index as j;">
                    <div class="alert alert-white border shadow-sm"
                        title="{{t('categories.card-title-subcategory', { subcat: subCategory.content['name'] })}}">
                        <div class="col d-flex align-items-center justify-content-between">
                            <div class="align-self-center">

                                @if(!subCatsArray || !this.auth.currentLangSig()?.lang) {
                                <div class="placeholder-glow">
                                    <span class="placeholder col-12 bg-dark">placeholderText</span>
                                </div>
                                }
                                @if(subCatsArray && this.auth.currentLangSig()?.lang) {
                                {{subCategory.content['name']}}
                                }
                            </div>
                            <div>
                                <span class="material-symbols-outlined method-button method-blue me-2"
                                    data-bs-target="#renameSubCategoryModal" data-bs-toggle="modal"
                                    (click)="this.selectedSubCategory = j"
                                    title="{{t('categories.title-rename-subcategory')}}">
                                    edit
                                </span>
                                <span class="material-symbols-outlined method-button method-red"
                                    data-bs-target="#deleteSubCategoryModal" data-bs-toggle="modal"
                                    (click)="this.selectedSubCategory = j;"
                                    title="{{t('categories.title-delete-subcategory')}}">
                                    delete
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                @if(subCatsArray.length < maxNumberOfSubcategories) { <div
                    class="col-xl-6 col-lg-12 col-md-6 col-sm-6 col-xs-1">
                    <div class="alert alert-white border-dashed">
                        <div class="col d-flex justify-content-center">
                            <span class="material-symbols-outlined method-button method-blue d-flex align-items-center"
                                style="height: 30px;" data-bs-target="#newSubCategoryModal" data-bs-toggle="modal"
                                title="{{t('categories.add-subcategory')}}">
                                add_circle
                            </span>
                        </div>
                    </div>
            </div>
            }
        </div>
    </div>
    <div class="modal-footer px-0">
        <div class="container-fluid">
            @if (!this.auth.currentLangSig()?.lang) {
            <p class="card-text placeholder-glow">
                <span class="placeholder bg-white col-8"></span>
                <span class="placeholder col-4"></span>
            </p>
            }
            @if (this.auth.currentLangSig()?.lang) {
            <div class="row">
                <div class="col-8 d-grid">

                </div>
                <div class="col-4 d-grid">
                    <button class="btn btn-sm btn-outline-secondary rounded-pill" data-bs-dismiss="modal" type="button"
                        title="{{t('general.button-close')}}">{{t('general.button-close')}}</button>
                </div>
            </div>
            }
        </div>
    </div>
</div>